import { useState } from 'react';

export default function useDrawerState() {
    const [leftDrawer, setLeftDrawer] = useState(false);

    const handleCloseLeftDrawer = () => setLeftDrawer(false);

    const handleHamburguerMenu = () => {
        setLeftDrawer((prev) => !prev);
    };

    return {
        leftDrawer,
        handleCloseLeftDrawer,
        handleHamburguerMenu,
    };
}
